import WorldSystem from '../WorldSystem';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import ITask from 'Utility/Task/ITask';
import WorldTaskHelper from './WorldTaskHelper';

export default class PreWorldSyncTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<number> {
        const validTasks = system.store.getState().playerState.tasks.filter(task => task.prePlayTask);
        for (const taskData of validTasks) {
            yield* WorldTaskHelper.executeTask(system, system.store.getState().playerState, taskData);
        }

        if (validTasks.length > 0) {
            PlayerActions.clearTasks(validTasks);
        }
    }
}
